<template>
  <b-sidebar
    id="member-sidebar"
    title="Member Detail"
    right
    backdrop
    shadow
    width="520px"
  >
    <div class="px-0 py-2 m-0 row">
      <div class="col-sm-6 p-2 d-flex flex-column ">
        <label class="h5">Name</label>
        <span>{{ member.name }}</span>
      </div>
      <div class="col-sm-6 p-2 d-flex flex-column ">
        <label class="h5">Contact</label>
        <span>{{ member.mobile }}</span>
      </div>
     <div class="col-sm-6 p-2 d-flex flex-column ">
        <label class="h5">Ethnic</label>
        <span>{{ member.ethnic }}</span>
      </div>
      <div class="col-sm-6 p-2 d-flex flex-column ">
        <label class="h5">Gender</label>
        <span>{{ member.gender == 0 ? 'Female':'Male' }}</span>
      </div>
      <div class="col-sm-6 p-2 d-flex flex-column ">
        <label class="h5">Birthday</label>
        <span>{{ member.dob }}</span>
      </div>
      <div class="col-sm-6 p-2 d-flex flex-column ">
        <label class="h5">Membership Tags</label>
        <div
          v-if="member.vip == '0' && member.vvip == '0' && member.vvvip == '0'"
        >
          <span class="badge border border-secondary text-secondary fw-400"
            >N/A</span
          >
        </div>
        <div class="d-fl" v-if="member.vip != '0'">
          <span class="badge badge-primary">Member</span>
        </div>
        <div class="" v-if="member.vvip != '0'">
          <span class="badge badge-danger">VVIP</span>
        </div>
        <div class="" v-if="member.vvvip != '0'">
          <span class="badge badge-warning">VVVIP</span>
        </div>
      </div>
      <div class="col-sm-6 p-2 d-flex flex-column ">
        <label class="h5">Credits</label>
        <span>{{ member.credits }}</span>
      </div>
      <div class="col-sm-6 p-2 d-flex flex-column ">
        <label class="h5">Outstandings</label>
        <span>{{ member.outstandings }}</span>
      </div>
    </div>
  </b-sidebar>
</template>
<script>
export default {
  name: "member-sidebar",
  props: {
    member: Object,
  },
  methods:{
    isEmpty(obj){
        return Object.keys(obj).length === 0;
    }
  }
};
</script>
